var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVirus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.3 58.3",
    style: {
      enableBackground: "new 0 0 58.3 58.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#A32F88;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:#A32F88;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.4,15.1c-7.1-4.1-16.2-1.7-20.3,5.4s-1.7,16.2,5.4,20.3s16.2,1.7,20.3-5.4c1.3-2.3,2-4.8,2-7.4 c0-1.1-0.1-2.3-0.4-3.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 47.9,
    y1: 28,
    x2: 56.3,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2,
    y1: 28,
    x2: 16.9,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 47.9,
    y1: 28,
    x2: 56.3,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2,
    y1: 28,
    x2: 16.9,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 47.9,
    y1: 28,
    x2: 56.3,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2,
    y1: 28,
    x2: 18.1,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 47.9,
    y1: 28,
    x2: 56.3,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.5,
    y1: 54.8,
    x2: 25.5,
    y2: 40.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 40.4,
    y1: 15.1,
    x2: 45.4,
    y2: 6.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18.8,
    y1: 3.5,
    x2: 25.5,
    y2: 15.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 40.4,
    y1: 40.9,
    x2: 44.7,
    y2: 48.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 36.7,
    cy: 23.3,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 26.8,
    cy: 27.1,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 36.7,
    cy: 32,
    r: 2.5
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVirus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/virus.87dbfd61.svg";
export { ForwardRef as ReactComponent };